import { useState, useEffect } from "react";
import { FaChevronDown, FaSearch, FaBars } from "react-icons/fa";
import { Link } from "react-router-dom";

const Header = ({ toggleOffcanvas, toggleSearch }) => {
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const controlHeader = () => {
    if (window.scrollY > lastScrollY) {
      // Scroll xuống
      setShowHeader(false);
    } else {
      // Scroll lên
      setShowHeader(true);
    }
    setLastScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", controlHeader);
    return () => {
      window.removeEventListener("scroll", controlHeader);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastScrollY]);
  return (
    <header
      id="header-sticky"
      className={`header-1 ${showHeader ? "header-show" : "header-hide"}`}
    >
      <div className="container">
        <div className="mega-menu-wrapper">
          <div className="header-main">
            {/* Logo */}
            <div className="logo">
              <Link
                to="/"
                className="header-logo"
              >
                <img
                  src="/logo-design24.webp"
                  alt="logo-img"
                />
              </Link>
            </div>

            {/* Menu */}
            <div className="mean__menu-wrapper">
              <div className="main-menu">
                <nav id="mobile-menu">
                  <ul>
                    {/* Trang chủ Dropdown */}
                    <li className="has-dropdown">
                      <Link
                        to="/"
                        className="header__nav-link"
                      >
                        Trang chủ <FaChevronDown />
                      </Link>
                      <ul className="submenu has-homemenu">
                        <li>
                          <div className="homemenu-items">
                            {/*Dịch vụ */}
                            <div className="homemenu">
                              <div className="homemenu-thumb">
                                <img
                                  src="/assets/img/header/home-1.jpg"
                                  alt="img"
                                />
                                <div className="demo-button">
                                  <Link
                                    to="/dich-vu"
                                    className="theme-btn header__nav-link"
                                  >
                                    Chi tiết
                                  </Link>
                                </div>
                              </div>
                              <div className="homemenu-content text-center">
                                <h4 className="homemenu-title">Dịch vụ</h4>
                              </div>
                            </div>

                            {/* Dự án */}
                            <div className="homemenu">
                              <div className="homemenu-thumb">
                                <img
                                  src="/assets/img/header/home-2.jpg"
                                  alt="img"
                                />
                                <div className="demo-button">
                                  <Link
                                    to="/du-an"
                                    className="theme-btn header__nav-link"
                                  >
                                    Chi tiết
                                  </Link>
                                </div>
                              </div>
                              <div className="homemenu-content text-center">
                                <h4 className="homemenu-title">Dự án</h4>
                              </div>
                            </div>

                            {/* Bạn cố vấn */}
                            <div className="homemenu">
                              <div className="homemenu-thumb">
                                <img
                                  src="/assets/img/header/home-3.jpg"
                                  alt="img"
                                />
                                <div className="demo-button">
                                  <Link
                                    to="/doi-ngu"
                                    className="theme-btn header__nav-link"
                                  >
                                    Chi tiết
                                  </Link>
                                </div>
                              </div>
                              <div className="homemenu-content text-center">
                                <h4 className="homemenu-title">Thành viên</h4>
                              </div>
                            </div>

                            {/* Tín tức */}
                            <div className="homemenu">
                              <div className="homemenu-thumb">
                                <img
                                  src="/assets/img/header/home-4.jpg"
                                  alt="img"
                                />
                                <div className="demo-button">
                                  <Link
                                    to="/bai-viet"
                                    className="theme-btn header__nav-link"
                                  >
                                    Chi tiết
                                  </Link>
                                </div>
                              </div>
                              <div className="homemenu-content text-center">
                                <h4 className="homemenu-title">Tin tức</h4>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </li>

                    {/* Giới thiệu */}
                    <li>
                      <Link
                        to="/gioi-thieu"
                        className="header__nav-link"
                      >
                        Giới thiệu
                      </Link>
                    </li>

                    {/* Dịch vụ  */}
                    <li>
                      <Link
                        to="/dich-vu"
                        className="header__nav-link"
                      >
                        Dịch vụ
                      </Link>
                    </li>

                    {/* Dự án  */}
                    <li>
                      <Link
                        to="/du-an"
                        className="header__nav-link"
                      >
                        Dự án
                      </Link>
                    </li>

                    {/* Tin tức  */}
                    <li>
                      <Link
                        to="/bai-viet"
                        className="header__nav-link"
                      >
                        Blogs
                      </Link>
                    </li>

                    {/*Thông tin  */}
                    <li className="has-dropdown">
                      <Link
                        to="#"
                        className="header__nav-link"
                      >
                        Thông tin <FaChevronDown />
                      </Link>
                      <ul className="submenu">
                        <li>
                          <Link
                            to="/doi-ngu"
                            className="header__nav-link"
                          >
                            Thành viên
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/cau-hoi-thuong-gap"
                            className="header__nav-link"
                          >
                            Câu hỏi thường gặp
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/lien-he"
                            className="header__nav-link"
                          >
                            Liên hệ
                          </Link>
                        </li>
                      </ul>
                    </li>
                    {/*Liên kết  */}
                    <li className="has-dropdown">
                      <Link
                        to="#"
                        className="header__nav-link"
                      >
                        Liên kết <FaChevronDown />
                      </Link>
                      <ul className="submenu">
                        <li>
                          <a
                            href="https://webapp24h.vn/"
                            className="header__nav-link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Website - App
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://design24.edu.vn/"
                            className="header__nav-link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Học viện Design24
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

            {/* Right Buttons */}
            <div className="header-right d-flex justify-content-end align-items-center">
              <div className="header-button">
                <button
                  type="button"
                  className="search-trigger search-icon"
                  aria-label="Mở ô tìm kiếm"
                  onClick={toggleSearch}
                >
                  <FaSearch aria-hidden="true" />
                </button>

                <Link
                  to="/lien-he"
                  className="theme-btn"
                >
                  Liên hệ
                </Link>
              </div>

              <div className="header__hamburger d-xl-block my-auto">
                <div
                  className="sidebar__toggle"
                  onClick={toggleOffcanvas}
                >
                  <FaBars />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
